import React from 'react';

// Import SVG files as React components
import { ReactComponent as ClusterSvg } from '../assets/icons/cluster.svg';
import { ReactComponent as DeploymentSvg } from '../assets/icons/deployment.svg';
import { ReactComponent as StatefulSetSvg } from '../assets/icons/statefulset.svg';
import { ReactComponent as DaemonSetSvg } from '../assets/icons/daemonset.svg';
import { ReactComponent as ReplicaSetSvg } from '../assets/icons/replicaset.svg';
import { ReactComponent as JobSvg } from '../assets/icons/job.svg';
import { ReactComponent as CronJobSvg } from '../assets/icons/cronjob.svg';
import { ReactComponent as PodSvg } from '../assets/icons/pod.svg';
import { ReactComponent as ServiceSvg } from '../assets/icons/service.svg';
import { ReactComponent as ApplicationSvg } from '../assets/icons/application.svg';
import { ReactComponent as NamespaceSvg } from '../assets/icons/namespace.svg';

const iconComponents = {
  cluster: ClusterSvg,
  deployment: DeploymentSvg,
  statefulset: StatefulSetSvg,
  daemonset: DaemonSetSvg,
  replicaset: ReplicaSetSvg,
  job: JobSvg,
  cronjob: CronJobSvg,
  pod: PodSvg,
  service: ServiceSvg,
  application: ApplicationSvg,
  namespace: NamespaceSvg,
};

export type KubernetesIconType = keyof typeof iconComponents;

interface KubernetesIconProps {
  type: KubernetesIconType;
  className?: string;
  size?: number;
}

export const KubernetesIcon: React.FC<KubernetesIconProps> = ({
  type,
  className = "",
  size = 16
}) => {
  const IconComponent = iconComponents[type];

  if (!IconComponent) {
    // Fallback for unknown types
    return (
      <div
        className={`inline-block bg-gray-400 rounded ${className}`}
        style={{ width: size, height: size }}
      />
    );
  }

  return (
    <div
      style={{ width: size, height: size }}
      className={`inline-block ${className}`}
    >
      <IconComponent
        width={size}
        height={size}
        className="w-full h-full"
      />
    </div>
  );
};

export default KubernetesIcon;